import React from "react";
import { useFormContext } from "react-hook-form";
import { ChevronDown, Info, LifeBuoy } from "react-feather";
import { Link } from "react-router-dom";
import Allowence from "./Components/Allowance";
import Deduction from "./Components/Deduction";

const option_2 = [
  { id: 1, text: "Yes" },
  { id: 2, text: "No" },
];

const AllowanceAndDeductions = () => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <>
      <div className="row">
        {/* <div className="card border-0"> */}
        <div className="card-body add-product pb-0">
          <div className="accordion-card-one accordion" id="accordionaddition">
            <div className="accordion-item">
              <div className="accordion-header" id="headingTwo">
                <div
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#addition"
                  aria-controls="addition"
                >
                  <div className="text-editor add-list">
                    <div className="addproduct-icon list icon">
                      <h5>
                        <Info className="add-info" />
                        <span>Addition Details</span>
                      </h5>
                      <Link to="#">
                        <ChevronDown className="chevron-down-add" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="addition"
                className="accordion-collapse collapse show"
                aria-labelledby="addition"
                data-bs-parent="#accordionaddition"
              >
                <div className="accordion-body">
                  <div className="row">
                    <Allowence />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-card-one accordion" id="accordiondeduction">
            <div className="accordion-item">
              <div className="accordion-header" id="headingTwo">
                <div
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#deduction"
                  aria-controls="deduction"
                >
                  <div className="text-editor add-list">
                    <div className="addproduct-icon list icon">
                      <h5>
                        <LifeBuoy className="add-info" />
                        <span>Deduction Details</span>
                      </h5>
                      <Link to="#">
                        <ChevronDown className="chevron-down-add" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="deduction"
                className="accordion-collapse collapse show"
                aria-labelledby="deduction"
                data-bs-parent="#accordiondeduction"
              >
                <div className="accordion-body">
                  <div className="row">
                    <Deduction />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      {/* <div className="row">
        <div className="col-md-6 col-lg-6">
          <Allowence />
        </div>
        <div className="col-md-6 col-lg-6">
          <Deduction />
        </div>
      </div> */}
    </>
  );
};

export default AllowanceAndDeductions;
